import { Form, Input, Select } from "antd";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { _i, __ } from "../../../../utils";
import { useAffiliateLanguage } from "../../../../hooks";
import { useStores } from "../../../../store";
const AccountAffiliateSignUpGeneralFields = observer(() => {
  const languages = useAffiliateLanguage();
  const {
    accountStore
  } = useStores();
  const {
    affiliateManufacturer: {
      name: affiliateName
    },
    isLoggedIn,
    isAffiliate,
    busyAffiliateProducts,
    affiliateProducts
  } = accountStore;
  useEffect(() => {
    accountStore.fetchAffiliateProducts();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Item, {
    name: ["user", "email"],
    label: __("Email address"),
    rules: [{
      type: "email",
      required: true,
      message: __("Please enter a valid email address!")
    }],
    required: true,
    extra: isLoggedIn && /*#__PURE__*/React.createElement(React.Fragment, null, __("The email address is automatically taken from your current account."), isAffiliate && _i(` ${__("If you want to change your email address, you can do so in the {{a}}account details{{/a}}.")}`, {
      a: /*#__PURE__*/React.createElement("a", {
        href: "#/details",
        target: "_blank",
        rel: "noreferrer"
      })
    }))
  }, /*#__PURE__*/React.createElement(Input, {
    disabled: isLoggedIn
  })), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Preferred language"),
    extra: __("We will get in touch with you sometimes, for that we need to know which language you prefer."),
    required: true,
    name: ["affiliate", "communicationLanguage"],
    rules: [{
      required: true,
      message: __("Please choose one option!")
    }]
  }, /*#__PURE__*/React.createElement(Select, null, Object.keys(languages).map(key => /*#__PURE__*/React.createElement(Select.Option, {
    key: key,
    value: languages[key]["value"]
  }, languages[key]["localized"])))), isAffiliate ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Payout threshold"),
    extra: __("Amount from which the payout should be made to your specified payment method. If the payout threshold has not been reached, the outstanding amount will be credited to the following month.", affiliateName),
    required: true,
    name: ["affiliate", "payoutThreshold"],
    rules: [{
      required: true,
      message: __("Please fill in your payout threshold!")
    }]
  }, /*#__PURE__*/React.createElement(Input, {
    type: "number",
    style: {
      maxWidth: 150
    },
    suffix: "EUR"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Products you want to promote"),
    extra: __("You can generate affiliate links for all products later, even if you are not yet interested."),
    required: true,
    name: ["interestedInProducts"],
    rules: [{
      required: true,
      message: __("Please choose at least one product!")
    }]
  }, /*#__PURE__*/React.createElement(Select, {
    mode: "multiple",
    loading: busyAffiliateProducts,
    showSearch: true,
    optionFilterProp: "children"
  }, affiliateProducts.map(_ref => {
    let {
      id,
      name
    } = _ref;
    return /*#__PURE__*/React.createElement(Select.Option, {
      key: id,
      value: id
    }, name);
  }))), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Promotion strategy"),
    extra: __("Where and how do you want to promote %s products? The more detailed you describe your plans, the better we can help you earn more commissions.", affiliateName.replace("GmbH", "")),
    required: true,
    name: ["affiliate", "descriptionOfAdvertisingActions"],
    rules: [{
      required: true,
      message: __("Please tell us your plans!")
    }]
  }, /*#__PURE__*/React.createElement(Input.TextArea, {
    autoSize: {
      minRows: 3,
      maxRows: 5
    },
    placeholder: __("I want to write a review about Real Cookie Banner on my-blog.com.")
  }))));
});
export { AccountAffiliateSignUpGeneralFields };